/* create html elements from array
 [{
	 type: html tag type (optionnal, default <div>)
	 class: element's class name (string or array),
	 text: element's inner html,
	 href: element's href
	 click: click event listener (function)
	 children: [] element's children
	 styles: object (key/value pair) of element's css styles where keys may be mediaQueries
	 attributes: object(key/value pair) of element's html attributes
 }]
*/

var m6CookiesEls = {
    init: function (els, parentEl) {
        for (var i in els) {
            if (els.hasOwnProperty(i)) {
                els[i].html = this.build(els[i]);

                if (els[i].children) {
                    this.init(els[i].children, els[i]);
                }
            }
        }
        this.append(els, parentEl);

        return els;
    },
    build: function (el) {
        var type = el.type ? el.type : 'div',
            href = el.href ? el.href : '#',
            node = document.createElement(type);

        if (el.id)
            node.setAttribute('id', el.id);

        if (el.text)
            node.innerHTML = el.text;

        if (type === 'a' || el.href)
            node.setAttribute('href', href);

        if (el.class) {
            var classNames = typeof el.class === 'string' ? el.class.split(',') : el.class;
            for (var c in classNames) {
                if (classNames.hasOwnProperty(c)) {
                    node.classList.add(classNames[c]);
                }
            }
        }

        for (var attr in el.attributes) {
            if (el.attributes.hasOwnProperty(attr)) {
                node.setAttribute(attr.replace(/([A-Z])/g, "-$1"), el.attributes[attr]);
            }
        }

        if (el.click) {
            node.onclick = function (e) {
                el.click(e);
            }
        }

        return node;
    },
    append: function (els, parentEl) {
        for (var i in els) {
            if (els.hasOwnProperty(i)) {
                var container = parentEl ? parentEl.html : document.body;
                container.appendChild(els[i].html);
            }
        }
    }
};

window.m6CookiesEls = m6CookiesEls;

// create <style> from element style parameters
var m6CookiesStyles = function (el) {
    var me = this;
    me.style = document.createElement("style");
    me.style.appendChild(document.createTextNode(""));

    document.head.appendChild(me.style);

    var setStyles = function (className, styles) {
        className = typeof className === 'object' ? '.' + className.join('.') : '.' + className;
        styles = typeof styles === 'string' ? {default: styles} : styles;

        for (var s in styles) {
            if (styles.hasOwnProperty(s)) {
                var elStyles = className + '{' + styles[s] + '}';

                if (el.mediaQueries[s])
                    elStyles = '@media only screen and (min-width : ' + el.mediaQueries[s] + 'px) {' + elStyles + '}';

                me.style.appendChild(document.createTextNode(elStyles));
            }
        }
    };

    var init = function (element) {
        for (var e in element) {
            if (element.hasOwnProperty(e)) {
                setStyles(element[e].class, element[e].style);

                if (element[e].children) {
                    init(element[e].children);
                }
            }
        }
    };

    init(el.html);

    return me.style;
};

window.m6CookiesStyles = m6CookiesStyles;

// user scroll event listener
var m6CookiesScroll = function () {
    var isScrollEnabled = true;
    if (window.hasOwnProperty('m6GdprJSONExtra') && typeof m6GdprJSONExtra === 'object') {
        if(typeof m6GdprJSONExtra.is_scroll_enabled === 'boolean')
            isScrollEnabled = m6GdprJSONExtra.is_scroll_enabled;
    }

    if(!isScrollEnabled) return;

    var me = this;
    me.listen = true;
    var dataSent = false;

    var callbackFn = function (e) {
        if (!me.listen) {
            return;
        }

        if (!dataSent) {
            window.dispatchEvent(new CustomEvent(m6Gdpr.REGISTER_GDPR_INFOS, {detail: {choices: '1:1,2:1,3:1,4:1'}}));
            window.dispatchEvent(new CustomEvent(m6Gdpr.REGISTER_IAB_INFOS, {detail: {choices: null}}));
            dataSent = true;
            window.cookieBar.close(e, true);
        }
    };

    document.addEventListener('keydown', function (e) {
        if (e.which === 33        // page up
            || e.which === 34     // page dn
            || e.which === 32     // spacebar
            || e.which === 38     // upx
            || e.which === 40     // down
            || (e.ctrlKey && e.which === 36)     // ctrl + home
            || (e.ctrlKey && e.which === 35)     // ctrl + end
        ) {
            callbackFn(e);
        }
    });

    ['DOMMouseScroll', 'wheel', 'scroll'].forEach(function (event) {
        document.addEventListener(event, callbackFn);
    });
};

window.m6CookiesScroll = m6CookiesScroll;

var m6CookiesDocumentClick = function () {
    var me = this;
    me.listen = true;

    var callbackFn = function (e) {
        if (!me.listen) {
            return;
        }

        if (e.target instanceof Element && null === e.target.closest('.m6Cookies_bar') && null === e.target.closest('.m6_pop-privacy') && null === e.target.closest('.m6Cookiespartners-overlay') && null === e.target.closest('.m6Cookiespartners-list-container')) {
            if (!m6Gdpr.hasCookieConsentement()) {
                window.dispatchEvent(new CustomEvent(m6Gdpr.REGISTER_GDPR_INFOS, {detail: {choices: '1:1,2:1,3:1,4:1'}}));
                window.dispatchEvent(new CustomEvent(m6Gdpr.REGISTER_IAB_INFOS, {detail: {choices: null}}));

                document.removeEventListener('click', callbackFn);
                window.cookieBar.close(e, true);
            }
        }
    };

    document.addEventListener('click', callbackFn);
};

window.m6CookiesDocumentClick = m6CookiesDocumentClick;
